import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, ArrowRight } from 'lucide-react';
export function TransformationSection() {
  const before = ['Confusión sobre cómo funciona el crédito', 'Malas decisiones financieras por desinformación', 'Puntaje bajo sin saber por qué', 'Estrés financiero constante'];
  const after = ['Claridad total sobre el sistema crediticio', 'Decisiones inteligentes basadas en estrategia', 'Mejor crédito con acciones concretas', 'Más oportunidades financieras y tranquilidad'];
  return <section className="py-24 bg-brand-gray" data-id="element-267">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-268">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-269">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-270">
            LO QUE CAMBIA CUANDO{' '}
            <span className="text-brand-green" data-id="element-271">ENTIENDES EL SISTEMA</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-272">
          {/* Before */}
          <motion.div className="rounded-2xl overflow-hidden shadow-sm border-2 border-red-100" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-273">
            <img src="https://cdn.magicpatterns.com/uploads/5QGYrXUVTGzn8aM41h6Gh5/ChatGPT_Image_25_may_2026,_08_07_09_p.m..png" alt="Antes: Confusión, malas decisiones, puntaje bajo y estrés financiero" className="w-full h-full object-cover" data-id="element-274" />
          </motion.div>

          {/* After */}
          <motion.div className="rounded-2xl overflow-hidden shadow-premium border-2 border-brand-green" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} data-id="element-275">
            <img src="https://cdn.magicpatterns.com/uploads/dc2hQzmA9B8Sm8Ux2E78Qh/ChatGPT_Image_25_may_2026,_08_12_16_p.m..png" alt="Después: Claridad, decisiones inteligentes, mejor crédito y tranquilidad" className="w-full h-full object-cover" data-id="element-276" />
          </motion.div>
        </div>

        {/* Arrow CTA */}
        <motion.div className="text-center mt-12" initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} data-id="element-277">
          <motion.button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="inline-flex items-center gap-3 px-10 py-5 bg-brand-green hover:bg-brand-dark text-white rounded-full font-bold text-xl transition-all shadow-premium hover:shadow-xl" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-278">
            QUIERO PASAR AL DESPUÉS <ArrowRight className="w-6 h-6" data-id="element-279" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}